import numeral from "numeral";
//import { useAppSelector } from "store/hooks";
import { useProject } from "utils/hooks/useProject";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

const EstimatedLoss: React.FC = () => {
    const { t } = useTranslation();
    const { isThermor } = useSalesNetwork();
    //const projectStore = useAppSelector((state) => state.project);
    const { getValue } = useProject();
    const deperds_TBase = +getValue("forms.heatModeStep.form.tbase");
    const deperds_Deperd = getValue("deperds.Deperd");
    const results_powerNeeded = getValue("results.E1[0].PowerNeeded");

    return (
        <>
            <group data-direction="column" data-length="autofit" data-justify="start"
                {...(isThermor ? { "data-border-color": "main-color-custom-border", "data-space": "20", "data-space-bottom": "0" } : {})}
            >
                <text
                    data-weight="600"
                    data-text-size="22"
                    data-ellipsis=""
                    data-space="5"
                >
                    {t("TITLE_ESTIMATED_LOSS")}
                </text>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("BASE_TEMPERATURE")} :</text><text data-text-size="large" data-weight="600">{(deperds_TBase as any).round(0)}&nbsp;°C</text></group>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("LOSS")} :</text><text data-text-size="large" data-weight="600">{numeral(deperds_Deperd.round(0)).format()}&nbsp;W</text></group>
                <group data-align="center" data-gap="5" data-space="5"><text>{t("REQUESTED_HEATING_CAPACITY")} :</text><text data-text-size="large" data-weight="600">{numeral(results_powerNeeded.round(0)).format()}&nbsp;W</text></group>
            </group>
        </>
    )
}

export default EstimatedLoss;